import { useMemo } from "react";
import { useAuth } from "@/features/auth/contexts/AuthContext";
import { userHasPermission } from "@/lib/user-permissions";

/**
 * Returns whether the current user has the given permission (dot format e.g. "sales.create").
 * Re-runs when user/auth changes.
 */
export function usePermission(permission: string | string[]): boolean {
	const { user } = useAuth();
	return useMemo(() => userHasPermission(user, permission), [permission, user]);
}
